<div class="my-profile-container p-4 ml-4 white-bg" [formGroup]="myProfileForm">
    <div class="header">
        <h2 class="my-profile-title black-text lightest-text m-0">{{metadata.labels[0]}}</h2>
        <img (click)="close()" class="close-img icon-s" src="assets/close-dialog.svg">
    </div>
    <div class="body">
        <div class="body-top border-light-bottom">
            <p class="mandatory-field alert-text pt-0 pr-1 pb-0 pl-0 content-s m-0">* mandatory</p>
            <div class="body-top-row-1">
                <div class="body-top-row-1-col-1">
                    <label class="bold-text span-l black-text">
                        {{metadata.labels[1]}}<span class="alert-text">*</span>
                    </label>
  
                </div>
                <div class="body-top-row-1-col-2">
                    <div class="input-box-type">
                        <input class="input-m input-border" type="text" specialCharOmit [charList]="inputBoxEmitChar" placeholder="Enter UserName" disabled formControlName="username">
                    </div>
                    <div class="alert-danger alert-text span-s">
                        <div *ngIf="username?.touched">{{metadata.username|oneError :username?.errors}}</div>
                    </div>
                </div>
            </div>
            <div class="body-top-row-2">
                <div class="body-top-row-2-col-1">
                    <label class="bold-text span-l black-text">
                        {{metadata.labels[2]}}<span>*</span>
                    </label>

                </div>
                <div class="body-top-row-2-col-2">
                    <div class="input-box-type">
                        <input class="input-m input-border" type="text" specialCharOmit [charList]="emailchar" placeholder="Enter Email Id" formControlName="email">
                    </div>
                    <div class="alert-danger alert-text span-s">
                        <div *ngIf="email?.touched||showerror">{{validationData.email.errors |oneError :email?.errors}}</div>
                    </div>
                </div>

            </div>
            <div class="body-top-row-3">
                <div class="body-top-row-3-col-1">
                    <label class="bold-text span-l black-text">
                        {{metadata.labels[3]}}<span>*</span>
                    </label>

                </div>
                <div class="body-top-row-3-col-2">
                    <div class="input-box-type">
                        <input class="input-m input-border" type="text" placeholder="Enter Mobile Number" formControlName="mobile">
                    </div>
                    <div class="alert-danger alert-text span-s">
                        <div *ngIf="mobile?.touched||showerror">{{validationData.mobile.errors |oneError: mobile?.errors}}</div>
                    </div>
                </div>

            </div>
        </div>
        <ng-container *ngIf="mat_spinner_userProfile_state" >
            <div class ="body-bottom-spinner secondary-side-nav-bg">
                <mat-spinner class="spinner mx-3 my-0" diameter=20></mat-spinner>
            </div>
        </ng-container>
        <div class="body-bottom">
            <div class="body-bottom-row-1 bold-text span-m black-text">
                <div class="body-bottom-row-1-col-1">
                    <label class="span-l">
                        {{metadata.labels[4]}}<span>*</span>
                    </label>
                </div>
                <div class="body-bottom-row-1-col-2">
                </div>

            </div>
            <div class="body-bottom-row-2">
                <div class="body-bottom-row-2-col-0">
                </div>
                <div class="body-bottom-row-2-col-1 span-l m-3">
                    <div class="body-bottom-row-2-col-1-row-1 span-l">
                        1.
                    </div>
                    <div class="body-bottom-row-2-col-1-row-2 span-l">
                        2.
                    </div>
                </div>
                <div class="body-bottom-row-2-col-2">
                    <div class="body-bottom-row-2-col-2-row-1">
                        <div class="body-bottom-row2-col-2-row-1-row-1 radius-s" #operatorOrigin>
                            <app-overlay-select formControlName="qtn1" fontsize=" input-m border-none shadow-none" [data]="qtnList" [origin]="operatorOrigin">
                            </app-overlay-select>
                        </div>
                        <div>
                        </div>
                    </div>

                    <div class="body-bottom-row-2-col-2-row-2">
                        <div class="body-bottom-row2-col-2-row-2-row-1 radius-s" #operatorOrigin2>
                            <app-overlay-select formControlName="qtn2" [data]="qtnList" fontsize="input-m border-none shadow-none" [origin]="operatorOrigin2">
                            </app-overlay-select>
                        </div>
                        <div class="alert-danger alert-text span-s" *ngIf="Ques2?.touched||showerror">
                            <div *ngIf="Ques2?.invalid && Ques2?.errors.samequestionerror">
                                {{metadata.samequestionerror.error}}</div>
                        </div>
                    </div>
                </div>
                <div class="body-bottom-row-2-col-3">
                    <div class="body-bottom-row-2-col-3-row-1">
                        <div class="input-box-type-small">
                            <input class="input-m input-border" type="text" specialCharOmit [charList]="inputBoxEmitChar" placeholder="Type your answer here" [type]="showans1 ? 'text':'password'"
                                formControlName="ans1">
                        </div>
                        <div class="alert-danger alert-text span-s">
                            <div *ngIf="ans1?.touched||showerror">{{validationData.secret_ques.errors |oneError : ans1?.errors}}</div>
                        </div>
                    </div> 
                    <div class="body-bottom-row-2-col-3-row-2">
                        <div class="input-box-type-small">
                            <input class="input-m input-border" type="text" specialCharOmit [charList]="inputBoxEmitChar" placeholder="Type your answer here" [type]="showans2 ? 'text':'password'"
                                formControlName="ans2">
                        </div>
                        <div class="alert-danger alert-text span-s">
                            <div *ngIf="ans2?.touched||showerror">{{validationData.secret_ques.errors |oneError : ans2?.errors}}</div>
                        </div>
                    </div>
                </div>
                <div class="body-bottom-row-2-col-4">
                    <div class="body-bottom-row-2-col-4-row-1">
                        <img class="preview-hide-1 icon-s" src="assets/preview_hide.svg" (click)="showans1 =! showans1"
                            *ngIf="!showans1">
                        <img class="preview-1 icon-s" src="assets/preview.svg" (click)="showans1 =! showans1" *ngIf="showans1">
                    </div>
                    <div class="body-bottom-row-2-col-4-row-2">
                        <img class="preview-hide-2 icon-s " src="assets/preview_hide.svg" (click)="showans2 =! showans2"
                            *ngIf="!showans2">
                        <img class="preview-2 icon-s" src="assets/preview.svg" (click)="showans2 =! showans2" *ngIf="showans2">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <button class="cancel " (click)="cancel()">{{commonData?.buttonLabels.cancel}}</button>
        <button class="submit " (click)="submitProfile_click()">{{commonData?.buttonLabels.submit}}</button>
    </div>
</div>